import MembershipProfile from '@components/membership/membership-profile/MembershipProfile'
import { useMembershipProfileContext } from '@contexts/membership/MembershipProfileContext'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Flex } from 'antd'

const EventParticipationsSection = () => {
  const { id } = useMembershipProfileContext()

  return (
    <Flex vertical gap={8}>
      <PageTitle level={5} title="Event Participations" style={{ margin: 0 }} />
      <MembershipProfile.EventParticipations id={id} />
    </Flex>
  )
}

export default EventParticipationsSection
